import { useState } from "react";
import Header from "../Header/Header";
import { Outlet, useLocation } from "react-router-dom";
import "../Header/header.scss"
import Sidebar from "../SideBar/SideBar";
import './layout.scss';

type Props = {};

const Layout = (props: Props) => {

    const location = useLocation();

    //state
    const [isSidebarOpen, setSidebarOpen] = useState(true);

    const isHomePage = location.pathname === '/home';

    return (
        <>
            <Header />
            <div className={`d-flex ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                <Sidebar isOpen={isSidebarOpen} />
                <div className={`cm-content-wrapper h-100 flex-fill ${isHomePage ? "px-0" : " p-3 px-md-4"}`} style={{ overflowX: "hidden" }}>
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default Layout;